//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IApiConfig } from './ApiConfig';
export class ApiClientBase {
    protected readonly config: IApiConfig;

    protected constructor(config: IApiConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
            ...options.headers,
            Authorization: this.config.getAuthorization(),
        };
        // See https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
        // We want the cookies to be sent with request (as long as the target domain matches) - VendorId cookie
        options.credentials = 'include';
        return Promise.resolve(options);
    };
}

export class AssetClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/mf-asset-api";
    }

    search(request: SearchAssetRequest, signal?: AbortSignal | undefined): Promise<SearchAssetResponse> {
        let url_ = this.baseUrl + "/api/Asset/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchAssetResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchAssetResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchAssetResponse>(null as any);
    }

    getById(assetId: string, signal?: AbortSignal | undefined): Promise<AssetModel> {
        let url_ = this.baseUrl + "/api/Asset/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<AssetModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetModel>(null as any);
    }

    createAsset(request: CreateAssetRequest, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Asset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAsset(_response);
        });
    }

    protected processCreateAsset(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateAsset(request: UpdateAssetRequest, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Asset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadAssetFile(assetId: string | undefined, assetTypeId: string | undefined, propertyId: string | undefined, photos: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Asset/Files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assetId === null || assetId === undefined)
            throw new Error("The parameter 'assetId' cannot be null.");
        else
            content_.append("AssetId", assetId.toString());
        if (assetTypeId === null || assetTypeId === undefined)
            throw new Error("The parameter 'assetTypeId' cannot be null.");
        else
            content_.append("AssetTypeId", assetTypeId.toString());
        if (propertyId === null || propertyId === undefined)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else
            content_.append("PropertyId", propertyId.toString());
        if (photos !== null && photos !== undefined)
            photos.forEach(item_ => content_.append("Photos", item_.data, item_.fileName ? item_.fileName : "Photos") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadAssetFile(_response);
        });
    }

    protected processUploadAssetFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PropertyClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/mf-asset-api";
    }

    suggest(query: string | null | undefined, signal?: AbortSignal | undefined): Promise<PropertySuggestionModel[]> {
        let url_ = this.baseUrl + "/api/Property/Suggest?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSuggest(_response);
        });
    }

    protected processSuggest(response: Response): Promise<PropertySuggestionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PropertySuggestionModel[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertySuggestionModel[]>(null as any);
    }

    get(propertyId: string | undefined, signal?: AbortSignal | undefined): Promise<PropertyModel> {
        let url_ = this.baseUrl + "/api/Property?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PropertyModel;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyModel>(null as any);
    }
}

export class ReferenceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/mf-asset-api";
    }

    getGlobalData(signal?: AbortSignal | undefined): Promise<GlobalReferenceDataModel> {
        let url_ = this.baseUrl + "/api/Reference/Global";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalData(_response);
        });
    }

    protected processGetGlobalData(response: Response): Promise<GlobalReferenceDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlobalReferenceDataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalReferenceDataModel>(null as any);
    }
}

export class UserClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/mf-asset-api";
    }

    getCurrentUser(signal?: AbortSignal | undefined): Promise<UserModel> {
        let url_ = this.baseUrl + "/api/User/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel>(null as any);
    }
}

export interface SearchAssetResponse {
    assets: AssetModel[];
    hasNextPage: boolean;
    totalCount: number;
}

export interface IdModel {
    id: string;
}

export interface EntityWithTypeModel extends IdModel {
    typeId: string;
    typeName?: string | undefined;
}

export interface AssetModel extends EntityWithTypeModel {
    name: string;
    description: string;
    attributes: AttributeModel[];
    property?: AssetPropertyModel | undefined;
    images: ImageModel[];
    parentId?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
}

export interface AttributeModel {
    key: string;
    value?: string | undefined;
}

export interface AssetPropertyModel extends IdModel {
    propertyNo: string;
    addressLine1?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
}

export interface ImageModel {
    id: string;
    largeUrl?: string | undefined;
    thumbnailUrl?: string | undefined;
}

export interface BaseResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export interface SearchAssetRequest {
    paging?: PagingModel | undefined;
    typeId?: string | undefined;
    searchText?: string | undefined;
    propertyId?: string | undefined;
    locationId?: string | undefined;
}

export interface PagingModel {
    pageIndex?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortAscending?: boolean;
}

export interface CreateAssetRequest {
    id?: string | undefined;
    name: string;
    assetTypeId: string;
    description?: string | undefined;
    locationId?: string | undefined;
    parentId?: string | undefined;
    propertyId: string;
    attributes?: { [key: string]: any; } | undefined;
}

export interface UpdateAssetRequest {
    id: string;
    name: string;
    assetTypeId: string;
    description?: string | undefined;
    parentId?: string | undefined;
    locationId?: string | undefined;
    propertyId: string;
    attributes?: { [key: string]: any; } | undefined;
    removedPhotoIds?: string[] | undefined;
}

export interface PropertySuggestionModel {
    id: string;
    address: string;
    propertyNo: string;
}

export interface PropertyModel {
    assets: PropertyAssetModel[];
    locations: PropertyLocationModel[];
}

export interface PropertyAssetModel extends IdModel {
    name: string;
    description: string;
}

export interface PropertyLocationModel extends IdModel {
    name: string;
    parentId?: string | undefined;
}

export interface GlobalReferenceDataModel {
    taxonomies?: { [key: string]: TaxonomyModel; } | undefined;
    assetTypeAttributes?: { [key: string]: AssetTypeAttributeModel[]; } | undefined;
}

export interface TaxonomyModel {
    name: string;
    items: TaxonomyItemModel[];
}

export interface TaxonomyItemModel {
    id: string;
    name: string;
    isHidden?: boolean | undefined;
}

export interface AssetTypeAttributeModel {
    key: string;
    name: string;
    isRequired?: boolean | undefined;
    type: AttributeValueType;
    isValueString?: boolean | undefined;
    isValueInt?: boolean | undefined;
    isValueDecimal?: boolean | undefined;
    isValueBool?: boolean | undefined;
    isValueDate?: boolean | undefined;
    isValueDateTime?: boolean | undefined;
    isValueTaxonomy?: boolean | undefined;
    items?: EnumModel[] | undefined;
}

export enum AttributeValueType {
    None = "None",
    String = "String",
    Int = "Int",
    Bool = "Bool",
    Decimal = "Decimal",
    Date = "Date",
    DateTime = "DateTime",
    Taxonomy = "Taxonomy",
}

export interface EnumModel {
    id: string;
    name?: string | undefined;
}

export interface UserModel {
    id?: string;
    permissions?: string[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/* tslint:disable */
/* eslint-disable */